var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 9.16671V13.3334M6.66659 6.66671V6.67504M9.99992 13.3334V9.16671M13.3333 13.3334V10.8334C13.3333 10.3913 13.1577 9.96742 12.8451 9.65486C12.5325 9.3423 12.1086 9.16671 11.6666 9.16671C11.2246 9.16671 10.8006 9.3423 10.4881 9.65486C10.1755 9.96742 9.99992 10.3913 9.99992 10.8334M3.33325 5.00004C3.33325 4.55801 3.50885 4.13409 3.82141 3.82153C4.13397 3.50897 4.55789 3.33337 4.99992 3.33337H14.9999C15.4419 3.33337 15.8659 3.50897 16.1784 3.82153C16.491 4.13409 16.6666 4.55801 16.6666 5.00004V15C16.6666 15.4421 16.491 15.866 16.1784 16.1786C15.8659 16.4911 15.4419 16.6667 14.9999 16.6667H4.99992C4.55789 16.6667 4.13397 16.4911 3.82141 16.1786C3.50885 15.866 3.33325 15.4421 3.33325 15V5.00004Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5adc2bb4aaed7306f65d44f4c59c1fc6.svg";
export { ForwardRef as ReactComponent };